import { isCoreElement } from '@tunasong/schemas'
import type { AudioEvent, CoreElement } from '@tunasong/schemas'
import type { EmbedSize } from '../element/sizable.js'
import type { Alignable } from '../element/alignment.js'

export interface Embed extends Alignable<CoreElement> {
  type: 'embed'
  service: string
  url?: string

  /** Layout */
  size: EmbedSize

  width?: string | number

  /** For audio/video events */
  events?: AudioEvent[]
}

export function isEmbed(node?: unknown): node is Embed {
  return Boolean(isCoreElement(node) && node.type === 'embed')
}

export interface YouTube extends Embed {
  service: 'youtube'
  mediaId?: string
  offset?: number
  url: string
}

export function isYouTube(element: unknown): element is YouTube {
  return Boolean(isEmbed(element) && element.service === 'youtube')
}

export interface Spotify extends Embed {
  service: 'spotify'

  /** URL on the format of https://open.spotify.com/${mediaType}/${mediaId} */
  url: string

  /** URI on the format of spotify:${mediaType}:${mediaId} */
  uri: string

  mediaType?: 'album' | 'song' | 'playlist'
  mediaId?: string
}

export function isSpotify(element: unknown): element is Spotify {
  return Boolean(isEmbed(element) && element.service === 'spotify')
}

export interface Tidal extends Embed {
  service: 'tidal'
  mediaId?: string
  mediaType?: 'album' | 'song' | 'playlist'
}

export function isTidal(element: unknown): element is Tidal {
  return Boolean(isEmbed(element) && element.service === 'tidal')
}

export interface Apple extends Embed {
  service: 'apple'
  mediaId?: string
  mediaType?: 'album' | 'song' | 'playlist'
}

export function isApple(element: unknown): element is Apple {
  return Boolean(isEmbed(element) && element.service === 'apple')
}

export interface Qobuz extends Embed {
  service: 'qobuz'
  mediaId?: string
  mediaType?: 'track' | 'album' | 'playlist'
}

export function isQobuz(element: unknown): element is Qobuz {
  return Boolean(isEmbed(element) && element.service === 'qobuz')
}
